// Included coverage belongs to the form submission, not a particular ATC click.
window.plungeAddIncludedProtection = async function(form, submittedVariant, quantity) {
    const config = JSON.parse(document.getElementById('plunge-included-protection')?.textContent || 'null');
    const referenceId = String(submittedVariant);
    if (window.Shopify?.currency?.active !== 'USD') return;
    if (!config || config.term !== 24 || config.price !== 0 || !config.variantIds.some(id => String(id) === referenceId)) return;
    if (!window.Extend?.getOffer || !window.ExtendShopify?.addPlanToCart) throw new Error('Protection is still loading. Please try again.');
    if (!window.plungeExtendConfigured) {
        window.Extend.config({ storeId: 'ff4da56f-8f64-4f20-93b8-c0d323f78f17', environment: 'production' });
        window.plungeExtendConfigured = true;
    }
    const variant = meta.product.variants.find(item => String(item.id) === referenceId);
    if (!variant) throw new Error('Please select your product again.');
    const offer = await Extend.getOffer({ referenceId, price: variant.price, category: meta.product.type });
    const plans = Array.isArray(offer?.plans) ? offer.plans : offer?.plans?.[offer.plans.recommended];
    const plan = plans?.find(item => item.contract?.termLength === 24);
    if (!plan?.id) throw new Error('Included two-year protection is unavailable.');
    if (referenceId !== String(form.querySelector('[name="id"]').value)) throw new Error('Your selection changed. Please add to cart again.');
    await new Promise((resolve, reject) => {
        ExtendShopify.addPlanToCart({
            plan: { planId: plan.id, price: 0, term: 24, title: plan.title, offerPlanId: plan.offerPlanId, token: plan.token, coverageType: plan.contract.coverageIncludes },
            product: { id: referenceId, name: offer.product.title, price: variant.price, category: meta.product.type },
            quantity: Number(quantity) || 1,
            offerType: { area: 'product_page', component: 'buttons' }
        }, error => error ? reject(error) : resolve());
    });
};

// ! ||--------------------------------------------------------------------------------||
// ! ||                                   PDP Offers                                   ||
// ! ||--------------------------------------------------------------------------------||
class ExtendProductOffer extends HTMLElement {
    constructor(productForm, addToCartButton) {
        super();

        const referenceId = productForm.id.value;
        const price = meta.product.variants.filter(variant => variant.id == referenceId)[0].price;
        const category = meta.product.type;

        this.params = {
            referenceId,
            price,
            category
        }

        this.config = getConfiguration();
        this.config.dispatchSideCart = false;

        this.productForm = productForm;
        this.addToCartButton = addToCartButton;
    }

    connectedCallback() {
        try {
            this.verifyProductOffer();
        } catch (err) {
            console.error(err.message);
            return;
        }

        this.bindEvents();
        this.style.display = 'block';

        this.updateIncludedProtectionDisplay();
        // Renders Extend offer
        Extend.buttons.render(this, this.params, () => {
            setTimeout(() => {
                window.dispatchEvent(new Event('resize'));
            }, 250);
        });
    }

    bindEvents() {
        this.handleAddToCart = this.handleAddToCart.bind(this);

        document.addEventListener('click', this.handleAddToCart, true)
        this.productForm.addEventListener('change', this.handleVariantChange.bind(this), true);
    }

    verifyProductOffer() {

        let elementsToCheck = [
            'this.productForm',
            'this.addToCartButton',
            'this.params.referenceId',
            'this.params.price',
            'this.params.category'
        ]

        let missingElements = elementsToCheck.filter((value) => {
            try {
                return !eval(value);
            } catch (err) {
                return true;
            }
        });

        if (missingElements.length) {
            let message = "The following value(s) are null or undefined:\n";
            missingElements.forEach((value) => {
                message += `\t${value}\n`;
            });
            throw new ExtendError(message);
        }

        // Checks if Extend lives in the window and the active currency is USD before showing Extend offers
        verifyExtend();

    }

    modalDone() {
        // remove default click listener
        document.removeEventListener('click', this.handleAddToCart, true);
        // click atc button
        (this.activeButton || this.addToCartButton).click();
        // add default click listener back
        document.addEventListener('click', this.handleAddToCart, true)
    }

    /**
    * Handle add to cart event with offers
    * @param {PointerEvent} e Click event from Add To Cart Button
    */
    handleAddToCart(e) {
        const button = e.target instanceof Element ? e.target.closest('button') : null;
        if (!button || button.type !== 'submit' || button.form !== this.productForm) return;
        if (button.name !== 'add' && !button.hasAttribute('data-sticky-atc-button')) return;
        // Free protection is awaited by ProductForm for main, sticky and keyboard submits.
        if (this.hasIncludedProtection()) return;
        this.activeButton = button;

        e.preventDefault();
        e.stopImmediatePropagation();

        const quantityEl = this.productForm.querySelector('[name="quantity"]');
        const quantity = quantityEl && quantityEl.value ? quantityEl.value : 1;

        if (this.hasIncludedProtection()) {
            this.addIncludedProtection(quantity);
            return;
        }

        ExtendShopify.handleAddToCart(this, {
            quantity: quantity,
            modal: this.config.offerModalEnabled,
            done: this.modalDone.bind(this)
        });
    }

    updateIncludedProtectionDisplay() {
        const included = this.hasIncludedProtection();
        this.style.display = (!this.config.pdpOfferEnabled || included) ? 'none' : 'block';
        if (!included) {
            // Server-rendered gift cards follow the approved product/campaign eligibility.
            // Do not remove them during a transient variant-form refresh.
            if (!this.includedProtectionNotice?.hasAttribute('data-included-protection-static')) {
                this.includedProtectionNotice?.remove();
                this.includedProtectionNotice = null;
            }
            return;
        }
        if (!this.includedProtectionNotice) {
            const template = document.getElementById('plunge-included-protection-notice');
            if (!template) return;
            // Reuse the card rendered in the shared accessories list; avoid duplicate gifts.
            this.includedProtectionNotice = this.productForm.closest('.product-details-block')?.querySelector('.plunge-included-protection') || document.querySelector('product-addons .plunge-included-protection') || template.content.firstElementChild.cloneNode(true);
            if (!this.includedProtectionNotice.isConnected) this.before(this.includedProtectionNotice);
        }
        // Place the included card in the existing accessories grid so it shares its native gap.
        const productSection = this.productForm.closest('.product-details-block');
        const addonList = productSection?.querySelector('product-addons .product-addons__wrapper') || document.querySelector('product-addons .product-addons__wrapper');
        if (addonList && addonList.firstElementChild !== this.includedProtectionNotice) {
            addonList.prepend(this.includedProtectionNotice);
        }
        const link = this.includedProtectionNotice.querySelector('[data-included-protection-details]');
        if (link) {
            link.onclick = async event => {
                event.preventDefault();
                if (link.getAttribute('aria-busy') === 'true') return;
                link.setAttribute('aria-busy', 'true');
                try {
                    const referenceId = String(this.productForm.id.value);
                    const variant = meta.product.variants.find(item => String(item.id) === referenceId);
                    const params = { referenceId, price: variant.price, category: this.params.category };
                    const offer = await Extend.getOffer(params);
                    const plans = Array.isArray(offer?.plans) ? offer.plans : offer?.plans?.[offer.plans.recommended];
                    const plan = plans?.find(item => item.contract?.termLength === 24);
                    if (referenceId !== String(this.productForm.id.value)) return;
                    Extend.learnMoreModal.open({ ...params, ...(plan?.url ? { planUrl: plan.url } : {}), isEmbedded: true });
                } catch (error) {
                    console.error('Unable to open Extend coverage details', error);
                } finally {
                    link.removeAttribute('aria-busy');
                }
            };
        }
    }

    hasIncludedProtection() {
        try {
            const config = JSON.parse(document.getElementById('plunge-included-protection')?.textContent || 'null');
            return config?.term === 24 && config.price === 0 &&
                config.variantIds.some(id => String(id) === String(this.productForm.id.value));
        } catch (_) {
            return false;
        }
    }

    async addIncludedProtection(quantity) {
        // Retain the normal SDK plan metadata and product linkage. Only the
        // merchant-funded BFCM plan is zero-priced; paid offers are unchanged.
        if (this.includedProtectionPending) return;
        this.includedProtectionPending = true;
        const referenceId = String(this.productForm.id.value);
        try {
            const offer = await Extend.getOffer({ ...this.params, referenceId });
            const plans = Array.isArray(offer?.plans) ? offer.plans : offer?.plans?.[offer.plans.recommended];
            const plan = plans?.find(item => item.contract?.termLength === 24);
            if (!plan?.id) throw new Error('Included two-year protection is unavailable.');
            if (referenceId !== String(this.productForm.id.value)) throw new Error('Your selection changed. Please add to cart again.');
            await new Promise((resolve, reject) => {
                ExtendShopify.addPlanToCart({
                    plan: {
                        planId: plan.id, price: 0, term: 24,
                        title: plan.title, offerPlanId: plan.offerPlanId,
                        token: plan.token, coverageType: plan.contract.coverageIncludes
                    },
                    product: { id: referenceId, name: offer.product.title, price: this.params.price, category: this.params.category },
                    quantity: Number(quantity) || 1,
                    offerType: { area: 'product_page', component: 'buttons' }
                }, error => error ? reject(error) : resolve());
            });
            this.modalDone();
        } catch (error) {
            console.error('Included protection could not be added:', error);
            let message = this.productForm.querySelector('[data-included-protection-error]');
            if (!message) {
                message = document.createElement('p');
                message.setAttribute('data-included-protection-error', '');
                message.setAttribute('role', 'alert');
                this.productForm.append(message);
            }
            message.textContent = 'We could not add your included protection. Please refresh the page and try again.';
        } finally {
            this.includedProtectionPending = false;
        }
    }

    handleVariantChange() {
        this.params.referenceId = this.productForm.id.value;
        this.params.price = meta.product.variants.filter(variant => variant.id == this.params.referenceId)[0].price;

        this.updateIncludedProtectionDisplay();
        Extend.setActiveProduct(this, this.params);
        setTimeout(() => {
            window.dispatchEvent(new Event('resize'));
        }, 250);
    }
}
if (!customElements.get('extend-offer'))
    customElements.define('extend-offer', ExtendProductOffer);

/**
* Initializes product offers and handles ATC button functionality for the main PDP ATC
*/
function initProductOffer() {
    try {
        if ((meta.page.pageType != 'product' || !meta.product))
            throw new ExtendError("Extend Product Offer - The current page is not a product page");
    } catch (err) {
        console.warn(err.message);
        return;
    }

    const productFormSelector = 'product-form form[action="/cart/add"]';
    const addToCartButtonSelector = 'button[name="add"]';

    const productForm = document.querySelector(productFormSelector);
    const addToCartButton = productForm ? productForm.querySelector(addToCartButtonSelector) : document.querySelector(addToCartButtonSelector);
    // Create offer and render it
    const extendOffer = new ExtendProductOffer(productForm, addToCartButton);

    document.querySelector('.extend-pdp-offer').append(extendOffer);
    //productForm.before(extendOffer);
}

// ! ||--------------------------------------------------------------------------------||
// ! ||                                   Cart Offers                                  ||
// ! ||--------------------------------------------------------------------------------||

const cartOfferTag = 'extend-cart-offer';

class ExtendCartOffer extends HTMLElement {

    constructor(referenceId, category, price, quantity, type) {
        super();
        this.params = {
            referenceId,
            category,
            price,
            quantity
        }
        this.type = type;

        this.config = getConfiguration();
    }

    connectedCallback() {
        if (!this.canDisplayOffer()) {
            return;
        }

        Extend.buttons.renderSimpleOffer(this, {
            ...this.params,
            onAddToCart: ({ plan, product }) => {
                ExtendShopify.addPlanToCart({
                    plan,
                    product,
                    quantity: this.params.quantity
                }, (err) => {
                    if (err) {
                        throw new ExtendError(err.message);
                    }

                    document.dispatchEvent(new CustomEvent('extend.plan-update', { detail: { offer: this } }));
                });
            }
        });
    }

    canDisplayOffer() {
        return (this.type === 'main' && this.config.cartOfferEnabled) || (this.type === 'side' && this.config.sideCartOfferEnabled);
    }
}

if (!customElements.get(cartOfferTag))
    customElements.define(cartOfferTag, ExtendCartOffer);

const initCartOffer = (() => {
    var cart;
    var init = false;

    const {
        cartOfferEnabled,
        cartSPEnabled,
        sideCartOfferEnabled,
        cartBalancingEnabled,
        SPEnabled
    } = getConfiguration();

    let type, selectors;
    if (meta.page.pageType === 'cart' && (cartOfferEnabled || cartSPEnabled)) {
        selectors = {
            cartContainer: 'cart-products',
            cartRowItem: '.cart-products__item', // Container element for each item in the cart
            cartRowItemImage: 'a.item__image', // Product image or image anchor element
            cartRowItemTitle: 'a.item__title', // Title anchor element for the product
            cartRowItemQuantity: 'input.quantity__input', // Input element containing the product quantity
            warrantyOriginalMeta: '.property', // Each warranty metadata item we want to remove.
            offerAnchor: '.item__details', // Container where the offer will be appended
            metadataContainer: '.properties-list', // Where warranty metadata will be appended (Product and Term)
            quantityWrapper: 'quantity-selector', // Wrapper for quantity input and buttons
        }
        type = 'main';
    } else if (sideCartOfferEnabled) {
        selectors = {
            cartContainer: 'cart-products',
            cartRowItem: '.cart-products__item',
            cartRowItemImage: 'a.item__image', // Product image or image anchor element
            cartRowItemTitle: 'a.item__title', // Title anchor element for the product
            cartRowItemQuantity: 'input.quantity__input', // Input element containing the product quantity
            warrantyOriginalMeta: '.null', // Each warranty metadata item we want to remove.
            offerAnchor: '.item__details', // Container where the offer will be appended
            metadataContainer: '.properties-list', // Where warranty metadata will be appended (Product and Term)
            quantityWrapper: 'quantity-selector', // Wrapper for quantity input and buttons
            lineItemRemove: 'remove-item-button button.remove-button',
        }
        type = 'side';
    }

    if (type === undefined || selectors === undefined) {
        throw new ExtendError('No cart type detected');
    }

    function createWarrantyOffer(lineItemElement, index) {
        if (!cartOfferEnabled) return;

        // Each cart item element has data-line set to the Shopify line item key (e.g. "40001234:abc123")
        // which matches cart.items[n].key — use this for reliable lookup
        const lineKey = lineItemElement.dataset.line;
        const cartItem = lineKey
            ? cart.items.find(item => item.key === lineKey)
            : cart.items[index];

        if (!cartItem) return;

        const referenceId = cartItem.variant_id;
        const quantity = cartItem.quantity;
        const price = cartItem.price;
        const category = cartItem.product_type;
        const warrantyAlreadyInCart = ExtendShopify.warrantyAlreadyInCart(referenceId, cart.items) || ExtendShopify.warrantyAlreadyInCart(referenceId.toString(), cart.items);

        let anchor = lineItemElement.querySelector(selectors.offerAnchor);

        if (!anchor) {
            throw new ExtendError(`Offer anchor element on line ${index} not found with selector ${selectors.offerAnchor}`);
        }

        let extendOffer = lineItemElement.querySelector(cartOfferTag);

        // If there's already an offer element, check that the properties match what we are trying to create
        // If they do not match, or the warranty is already in cart, remove the offer
        if (extendOffer) {
            if ((extendOffer.params.referenceId !== referenceId ||
                extendOffer.params.quantity !== quantity ||
                extendOffer.params.price !== price ||
                extendOffer.params.category !== category) ||
                warrantyAlreadyInCart
            ) {
                extendOffer.remove();
                // If they do match and the warranty is not already in the cart, do not create a new offer
            } else {
                return;
            }
            // If there is no offer element, but the warranty is already in cart, do not create a new offer
        } else if (warrantyAlreadyInCart) {
            return;
        }

        let newExtendOffer = new ExtendCartOffer(referenceId, category, price, quantity, type);

        anchor.append(newExtendOffer); // append, prepend, after, before
    }

    function styleWarrantyLineItem(lineItemElement, index) {
        const title = lineItemElement.querySelector(selectors.cartRowItemTitle);
        title.style.pointerEvents = 'none';
        title.innerText = 'Extend Protection Plan';

        const image = lineItemElement.querySelector(selectors.cartRowItemImage);

        if (image) {
            image.style.pointerEvents = 'none';
        } else {
            console.error(`EXTEND: Line item image element on line ${index} not found with selector ${selectors.cartRowItemImage}`)
        }

        const warrantyMetadata = lineItemElement.querySelector(selectors.warrantyOriginalMeta);

        if (warrantyMetadata) {
            warrantyMetadata.remove();
        }

        if (selectors.quantityWrapper?.length && lineItemElement.querySelector(selectors.quantityWrapper)) {
            lineItemElement.querySelectorAll(selectors.quantityWrapper).forEach((each) => {
                each.style.opacity = '75%';
                each.style.pointerEvents = 'none';
            });
        }
    }

    function formatLineItems() {
        let cartContainer = document.querySelector(selectors.cartContainer);

        if (!cartContainer) {
            throw new ExtendError(`Invalid cart container selector: ${selectors.cartContainer}`);
        }

        cartContainer.querySelectorAll(selectors.cartRowItem).forEach((lineItemElement, index) => {
            let title = lineItemElement.querySelector(selectors.cartRowItemTitle);

            if (!title) {
                throw new ExtendError('Line item title not found');
            }

            let lowerCaseTitle = title.innerHTML.toLowerCase();

            if (lowerCaseTitle.includes('extend protection')) {
                styleWarrantyLineItem(lineItemElement, index);
            } else {
                createWarrantyOffer(lineItemElement, index);
            }
        });
    }

    function normalizeItems(callback) {
        if (SPEnabled) {
            ExtendShopify.updateExtendLineItems({
                balanceCart: cartBalancingEnabled,
                isSPSupported: cartSPEnabled,
                callback
            });
        } else {
            let normalizationOpts = {
                balance: cartBalancingEnabled
            }
            ExtendShopify.normalizeCart(normalizationOpts, callback);
        }
    }

    function refreshCart(normalize) {
        if (type === 'side') {
            location.reload();
        } else if (type === 'main') {
            location.reload();
        } else {
            window.location.reload();
        }
    }

    function verifyCartOffers() {
        verifyExtend();

        let error = '';
        if (!selectors) error = `Cart selectors are empty\n`;

        if (!type) error += `Cart type not defined\n`;

        if (error.length > 0) {
            throw new ExtendError(`Cannot initialize cart offers due to following errors:\n${error}`);
        }
    }

    function initEventListeners() {
        if (type === 'main') {
            // cart-products.updateElements() replaces #cart-items innerHTML after every cart change.
            // Observe direct children of #cart-items so we re-render offers after each update
            // without triggering on offer elements appended deeper in the subtree.
            const cartItemsEl = document.getElementById('cart-items');
            if (cartItemsEl) {
                new MutationObserver(() => {
                    onCartUpdate();
                }).observe(cartItemsEl, { childList: true });
            }

            document.addEventListener('cart_item_removed', () => {
                initCartOffer();
            })
        }

        if (type === 'side') {

        }

        document.addEventListener('extend.plan-update', (e) => {
            if (type === 'side') {
                e.detail.offer.remove()
            }
            refreshCart();
        });

        init = true;
    }

    function onCartUpdate() {
        normalizeItems((err, data) => {
            cart = data?.cart

            if (err) {
                throw new ExtendError(err.message);
            }

            if (data?.updates) {
                refreshCart(true);
            } else {
                formatLineItems();
            }
        });
    }

    return function initCartOffer() {
        verifyCartOffers();

        try {
            if (!/cart/.test(window.location.pathname) && !sideCartOfferEnabled) {
                throw new ExtendError('Cannot initialize cart offers - not a cart page');
            }
        } catch (err) {
            console.warn(err.message);
            return;
        }

        if (!init) initEventListeners();

        onCartUpdate()
    }
})()

// ! ||--------------------------------------------------------------------------------||
// ! ||                                      Utils                                     ||
// ! ||--------------------------------------------------------------------------------||
class ExtendError extends Error {
    constructor(message) {
        super(message);
    }
}

function getConfiguration() {
    return {
        currency: 'USD',
        pdpOfferEnabled: true,
        offerModalEnabled: true,
        cartOfferEnabled: true,
        sideCartOfferEnabled: true,
        cartBalancingEnabled: true,
        aftermarketModalEnabled: true,
        atcOfferEnabled: true,
        quickviewOfferEnabled: true,
        quickviewModalOfferEnabled: true,
        cartSPEnabled: false,
        SPEnabled: false,
    };
}

function verifyExtend() {
    const propertiesToCheck = [
        'window.Extend',
        'window.ExtendShopify',
        'window.Shopify',
        'window.Shopify.currency.active'
    ];

    function checkPropertyExists(path) {
        return path.split('.').reduce((obj, prop) => obj && obj[prop], window) !== undefined;
    }

    let errors = propertiesToCheck.filter(prop => !checkPropertyExists(prop));

    // Check for currency mismatch
    if (window.Shopify?.currency?.active !== getConfiguration().currency) {
        errors.push('window.Shopify.currency.active == config.currency');
    }

    if (errors.length) {
        let message = "The following value(s) are null, undefined, or false:\n";
        errors.forEach((error) => {
            message += `\t${error}\n`;
        });
        throw new ExtendError(message);
    }
}

function initAftermarket() {
    try {
        verifyExtend();

        // Get params from URL
        const params = (new URL(document.location)).searchParams;

        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
            ? params.get('leadToken')
            : params.get('leadtoken');

        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError(error.message);
    }
}

function getCart() {
    return fetch('/cart.js', {
        credentials: 'same-origin',
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
        }
    }).then(e => e.json());
}

// Integration init
window.addEventListener('DOMContentLoaded', () => {
    try {
        const storeId = 'ff4da56f-8f64-4f20-93b8-c0d323f78f17';
        const environment = 'production';

        window.Extend.config({ storeId, environment });
        window.plungeExtendConfigured = true;

        const config = getConfiguration();

        if (config.aftermarketModalEnabled)
            initAftermarket();

        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        console.error(err);
    }
});